import PropTypes from "prop-types";
import type { Ref } from "react";

export { Label, Props as LabelProps };

type Props = {
  className?: string;
  onClick?(): void;
  color?: string;
  backgroundColor?: string;
  children: PropTypes.ReactNodeArray | PropTypes.ReactNodeLike;
  onMouseEnter?: VoidFunction;
  onMouseLeave?: VoidFunction;
};

const Label = ({
  ref,
  ...props
}: Props & {
  ref?: Ref<HTMLLabelElement>;
}) => {
  return (
    <label
      ref={ref}
      className={"label " + (props.className ?? "")}
      onClick={props.onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      style={{
        color: props.color,
        backgroundColor: props.backgroundColor,
      }}
    >
      {props.children}
    </label>
  );
};
